import { ReactComponent as CloseIcon } from '@assets/icons/close.svg';
import { Logo, ScreenReaderLabel } from '@components/core';
import { Cell } from '@components/grid';
import { Link } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';

const CloseMenuButton = styled.button.attrs({
  ariaLabel: 'Close Main Menu',
})`
  background: none;
  width: 40px;
  height: 40px;
  padding: 8px;

  border: none;
  outline: none;

  svg {
    fill: ${props => props.theme.color};
    height: 24px;
    width: 24px;
  }

  :hover {
    background: rgba(0, 0, 0, 0.2);
  }
`;

const HeaderWrapper = styled(Cell)`
  padding: 18px 0;
  margin-bottom: 30px;
  display: flex;

  justify-content: space-between;
  align-items: center;
  align-content: stretch;
`;

const MobileMenuHeader = ({ toggleOpen }) => (
  <HeaderWrapper>
    <Link to="/">
      <Logo />
      <ScreenReaderLabel>Home Page</ScreenReaderLabel>
    </Link>
    <CloseMenuButton onClick={toggleOpen}>
      <CloseIcon />
      <ScreenReaderLabel>Close Menu</ScreenReaderLabel>
    </CloseMenuButton>
  </HeaderWrapper>
);

export default MobileMenuHeader;
